// NOTE: NSAI-5409 — the shape check every client runs before it treats a
// string as an in-app path (a redirect target, a remembered destination).
//
// A prefix check of `startsWith("/") && !startsWith("//")` is not enough: the
// WHATWG URL parser treats "\" exactly like "/" in http(s) URLs and silently
// strips tab / CR / LF, so "/\evil.example" and "/\t/evil.example" get past
// that prefix test yet resolve to https://evil.example. No legitimate in-app
// path contains a backslash or a control character, so they are refused.
//
// This is the platform-agnostic floor. It deliberately does not parse the
// value with `URL`: React Native ships only a partial `URL` polyfill, so the
// mobile app cannot rely on it. The web app layers a real same-origin
// resolution on top (`toSafeSameOriginPath` in `apps/nsai/web/src/lib/safe-redirect.ts`).

const LAST_C0_CONTROL_CODE_POINT = 0x1f;
const DELETE_CODE_POINT = 0x7f;

const isUnsafePathCharacter = (character: string): boolean => {
  if (character === "\\") return true;

  const codePoint = character.codePointAt(0) ?? 0;

  return (
    codePoint <= LAST_C0_CONTROL_CODE_POINT || codePoint === DELETE_CODE_POINT
  );
};

export const isInAppPathShape = (candidate: unknown): candidate is string => {
  if (typeof candidate !== "string") return false;
  if (!candidate.startsWith("/") || candidate.startsWith("//")) return false;

  return !Array.from(candidate).some(isUnsafePathCharacter);
};
